<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="false"
      @close="closeDialog"
      class="dialog_modal dialog_800"
      append-to-body
      title="Supply Chain List"
    >
      <div class="detail_cont">
        <div class="flex_center tab-margin-bottom">
          <ul class="flex_center Data-Management-ul" style="width: 100%">
            <li
              style="width: 50%; text-align: center"
              v-for="(item, index) in managementMenu"
              @click="MenuClick(item)"
              :class="
                menuActive == item.value
                  ? 'menuActiveColor font18 font_bold'
                  : 'font18'
              "
              :key="index"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <div class="table_box p_l_n">
          <el-table
            ref="treeTable"
            class="table_height_50 table_contentHeight_40 computer_right_cont_box"
            :data="managementTable1"
            border
            show-overflow-tooltip
            tooltip-effect="light"
          >
            <!-- 空数据状态的插槽 -->
            <template slot="empty"> No Data </template>
            <el-table-column
              label="Company Name"
              prop="name"
              align="left"
              show-overflow-tooltip
              :resizable="false"
              class-name="company_link"
              tooltip-effect="light"
            >
              <template slot-scope="scope">
                <span class="">{{ scope.row.companyName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Destination"
              v-if="menuActive == 1"
              prop="countryName"
              align="left"
              show-overflow-tooltip
              :resizable="false"
              tooltip-effect="light"
            />
            <el-table-column
              label="Origin"
              v-else
              prop="countryName"
              align="left"
              show-overflow-tooltip
              :resizable="false"
              tooltip-effect="light"
            />
          </el-table>
          <div class="page_i_box">
            <Page
              :totalFont="true"
              :total="pageTree.total"
              :pageSize.sync="pageTree.pageSize"
              :currentPage="pageTree.pageNo"
              @onPageChange="onPageChangeListTree"
            ></Page>

            <div class="search_rsult_txt line_2">
              {{ pageTree.pageNo }}-{{ pageTree.pageSize }} of over
              {{ pageTree.total | FilterNum }} results for "Supply Chain List"
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog_footer">
        <button type="button" class="el-close" @click="closeDialog">
          <span>Close</span>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSupplyChainList } from "@/api/companyApi";
import Page from "@/components/page/index.vue";

export default {
  components: {
    Page,
  },

  props: {
    suoClose: {
      type: Boolean,
      //   default: false,
    },
    ContactObj: {
      type: Object,
    },
    IsCountry: {
      type: Boolean,
      default: false,
    },
    IsHsCode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageTree: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      managementMenu: [
        {
          label: "Suspected purchaser",
          value: "1",
        },
        {
          label: "Suspected supplier",
          value: "2",
        },
      ],
      menuActive: 1,
      managementTable1: [],
      //page: this.currentPage

      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        if (this.suoClose) {
          console.log(this.ContactObj);

          this.searhinfo();
        }
        return this.suoClose;
      },
      set() {},
    },
  },
  destroyed() {
    // bus.$off('handleShowLogin');
  },
  mounted() {},
  methods: {
    MenuClick(item) {
      this.pageTree.pageNo = 1;
      this.pageTree.pageSize = 10;
      this.menuActive = item.value;
    },
    onPageChangeListTree({ page, size }) {
      this.pageTree.pageNo = page;
      this.pageTree.size = size;
      this.searhinfo();
    },
    searhinfo() {
      let params = {};
      console.log(this.IsCountry);

      params = {
        page: this.pageTree.pageNo,
        pageSize: this.pageTree.pageSize,
        tradeCode: this.IsHsCode ? this.ContactObj.hsCode : "",
        tradeType: this.menuActive,
        aaaid: this.IsHsCode ? "" : this.ContactObj.aaa_id,
        countryCode: this.IsHsCode ? "" : this.ContactObj.company_country,
      };

      getSupplyChainList(params).then((result) => {
        if (result.code == 200) {
          this.managementTable1 =
            result.data?.rows == undefined ? [] : result.data?.rows;
          this.pageTree.total =
            result.data?.total == undefined ? "" : result.data?.total;
        } else {
          this.managementTable1 = [];
          this.pageTree.total = 0;
        }
      });
    },
    //关闭弹窗
    closeDialog() {
      this.pageTree.pageNo = 1;
      this.pageTree.pageSize = 10;
      this.$emit("clossuoDialogtwo", false);
    },
  },
};
</script>
<style scoped>
.detail_cont {
  max-height: 68%;
  overflow: auto;
}
::v-deep .el-dialog__headerbtn {
  height: 18px !important;
  width: 18px !important;
  top: 20px !important;
  right: 20px !important;
}
::v-deep .el-dialog__body {
  padding: 20px !important;
  box-shadow: none;
}

.el-close {
  width: 210px;
  height: 60px;
  background: #009ea7;
  border-radius: 10px;
  color: #ffffff;
  font-size: 20px;
  font-family: "Arial Bold";
}

.tab-margin-bottom {
  margin-bottom: 11px;
}
::v-deep .el-table__header-wrapper {
  width: 760px !important;
  height: 49px !important;
  font-size: 18px !important;
  line-height: 24px !important;
}
::v-deep .el-table td.el-table__cell {
  height: 60px !important;
}
::v-deep .table_box .el-table th > .cell {
  padding-left: 10px !important;
}
::v-deep .el-table--border .el-table__cell:first-child .cell {
  padding-left: 20px !important;
  font-size: 18px !important;
}
::v-deep .el-table__body tr:hover > td {
  background-color: #eafafa !important;
}
::v-deep .el-table ::-webkit-scrollbar {
  height: 0px !important;
}
.search_rsult_txt {
  position: relative;
  width: auto;
  height: auto;
  font-size: 16px;
  top: 0;
}
.pageBox_right {
  height: 45px !important;
  font-size: 16px !important;
}
.dialog_800 >>> .el-dialog__footer {
  padding-top: 0;
}
.dialog_800 >>> .el-dialog__header {
  padding-bottom: 0;
  padding-top: 20px;
}
.dialog_800 >>> .el-dialog__title {
  font-family: "Arial Bold";
  font-size: 26px;
  line-height: auto;
  color: #1a2332;
}
.computer_right_cont_box {
  max-height: 440px;
  overflow-y: auto;
  width: 760px;
  border-radius: 8px;
  border: 1px solid #cccccc;
}
.page_i_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
}
@media (max-width: 1920px) {
  .el-close {
    width: 157px;
    height: 45px;
    background: #009ea7;
    border-radius: 7px;
    color: #ffffff;
    font-size: 18px;
    font-family: "Arial Bold";
  }
  .tab-margin-bottom {
    margin-bottom: 8px;
  }
  ::v-deep .el-table td.el-table__cell {
    height: 45px !important;
  }
  ::v-deep .table_box .el-table th > .cell {
    padding-left: 7px !important;
  }
  ::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 15px !important;
    font-size: 16px !important;
  }
  .search_rsult_txt {
    font-size: 14px;
  }
  .pageBox_right {
    height: 30px !important;
    font-size: 14px !important;
  }
  .pageBox {
    height: 40px !important;
  }
  .dialog_800 >>> .el-dialog__title {
    font-size: 20px;
  }
  .dialog_800 >>> .el-dialog__header {
    padding-top: 15px;
  }
  ::v-deep .el-dialog__body {
    padding: 15px !important;
  }
  .computer_right_cont_box {
    border-radius: 6px;
  }
}
@media (max-width: 1439px) {
  .el-close {
    width: 140px;
    height: 40px;
    background: #009ea7;
    border-radius: 6px;
    color: #ffffff;
    font-size: 16px;
    font-family: "Arial Bold";
  }
  ::v-deep .el-dialog__headerbtn {
    height: 18px !important;
    width: 18px !important;
    top: 20px !important;
    right: 20px !important;
  }
  .tab-margin-bottom {
    margin-bottom: 7px;
  }
  ::v-deep .table_box .el-table th > .cell {
    padding-left: 6px !important;
  }
  ::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 13px !important;
    font-size: 14px !important;
  }
  .search_rsult_txt {
    font-size: 12px;
  }
  .pageBox_right {
    height: 30px !important;
    font-size: 12px !important;
  }
  .dialog_800 >>> .el-dialog__header {
    padding-top: 12px;
  }
  .dialog_800 >>> .el-dialog__title {
    font-size: 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 12px !important;
  }
  .computer_right_cont_box {
    border-radius: 5px;
  }
}
</style>
